export enum Permissions {
    Exam = 'ExamPermission',
    ExamFolder = 'ExamFolderPermission',
    ExamSchedule = 'ExamSchedulPermission',
    ExamViolations = 'ExamViolationsPermission',
    FormSetup = 'FormSetupPermission',
    QuestionsAndAnswers = 'QauestionsAndAnswersPermission',
    Report = 'ReportPermission',
    Summary = 'SummaryPermission',
    AddDelete = 'AddDeletePermission',
    Settings = 'SettingsPermission'
  }
  